export default function About() {
  return (
    <>
      <div></div>
    </>
  );
}
